import MojitoCore from 'mojito/core';
import DataProvidersTypes from 'services/sports-content/content-provider/types.js';

const DataProvider = MojitoCore.Services.DataProvider;
const {
    EventStreamsSpecProvider: { COLLECTION_NAME },
} = DataProvidersTypes;

/**
 * Class offering subscriptions to per-event stream descriptor payloads (stream specs).
 *
 * @class EventStreamsSpecProvider
 * @extends Mojito.Core.Services.DataProvider
 * @memberof Mojito.Services.SportsContent.DataProviders
 */
class EventStreamsSpecProvider extends DataProvider {
    init() {
        super.addSimpleCollection(COLLECTION_NAME);
    }

    subscribeToEntity(eventId, onUpdate) {
        return super.subscribeToEntity(eventId, onUpdate, COLLECTION_NAME);
    }
}

export default new EventStreamsSpecProvider();
